<template>
  <dd-customer-page header="Polissen">
    <template v-slot:tabs>
      <dd-tab-group id="foo">
        <dd-tab>
          <dd-avatar-and-name name="Koen Pieter" :customer-id="1"></dd-avatar-and-name>
        </dd-tab>
        <dd-tab>
          <dd-avatar-and-name name="Koen Pieter" :customer-id="1"></dd-avatar-and-name>
        </dd-tab>
      </dd-tab-group>
    </template>

    <template v-slot:content>
      <div id="foo" class="tab-content-wrapper">
        <div class="tab-content">
          <dd-card>
            <dd-form>
              <dd-step title="Basis">
                <dd-input title="Type pizza" v-model="inputValue" rules="email">

                </dd-input>
              </dd-step>
              <dd-step title="Adress">
                <dd-input title="Type huis" v-model="secondInputValue" rules="email">

                </dd-input>
              </dd-step>
            </dd-form>
          </dd-card>
        </div>
        <div class="tab-content">
          Tab 2
        </div>
        <div class="tab-content">
          Tab 3
        </div>
      </div>

    </template>
    <template v-slot:buttons>
      <dd-rounded-button icon="mdi mdi-plus">
        Nieuw pakket
      </dd-rounded-button>
      <dd-rounded-button type="primary" :outline="true" icon="mdi mdi-plus">
        Nieuwe polis
      </dd-rounded-button>
      <dd-rounded-button type="success" icon="mdi mdi-plus">
        Nieuwe polis
      </dd-rounded-button>
      <dd-rounded-button type="secondary" icon="mdi mdi-plus">
        Nieuwe polis
      </dd-rounded-button>
      <dd-rounded-button type="warning" icon="mdi mdi-plus">
        Nieuwe polis
      </dd-rounded-button>
      <dd-rounded-button type="danger" icon="mdi mdi-plus">
        Polissen verhuizen
      </dd-rounded-button>
    </template>


  </dd-customer-page>
</template>

<script>
export default {
  name: "PolissenPage.vue",
  data() {
    return {
      inputValue: 'foo',
      secondInputValue: 'bar',
      table: {
        headers: [

          {
            title: 'qux',
            key: 'qux',
            type: String,
          },
          {
            title: 'quux',
            key: 'quux',
            type: String,
          }
        ],
        rows: [
          {
            id: 0,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor',
          },
          {
            id: 1,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          // Additional rows
          {
            id: 2,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          {
            id: 3,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          {
            id: 4,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          {
            id: 5,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          {
            id: 6,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          {
            id: 7,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          {
            id: 8,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          },
          {
            id: 9,
            foo: 'bar',
            bar: 'bar',
            baz: 'lorem',
            qux: 'ipsum',
            quux: 'dolor'
          }
        ]
      },
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
